import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { setRecommendationsList, setMemberRecommendations } from '../../../../store/recommendationSlice';
import { getRecommendationsList } from '../../../../api/recommendation';
import RecommendationsTableRow from './RecommendationsTableRow';
import './RecommendationsTable.scss';
import TableHeader from '../../../BaseComponents/TableHeader';
import Loader from '../../../BaseComponents/Loader';

const headerColumns = [
  { title: 'Image', key: 'image', minWidth: '150px', flex: 0 },
  { title: 'Title', key: 'title', minWidth: '400px', flex: 0 },
  { title: 'Description', key: 'description', minWidth: '400px', flex: 1 },
  { title: '', key: 'actions', minWidth: '50px', flex: 0 }
];

export interface SelectedCategoryType {
  key: string;
  value: string;
}

interface RecommendationsTableProps {
  selectedCategory: SelectedCategoryType | null;
}

const RecommendationsTable = ({
  selectedCategory
}: RecommendationsTableProps) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<any>(null);
  const { memberRecommendations } = useSelector(
    (state: RootState) => state.recommendations
  );
  const { memberData } = useSelector((state: RootState) => state.member);
  const memberUserId = memberData?.user_id;

  const fetchAllRecommendations = useCallback(async () => {
    try {
      setLoading(true);
      const recommendationsList = await getRecommendationsList(0, 1000);
      dispatch(setRecommendationsList(recommendationsList));
      try {
        setLoading(true);
        const memberRecommendationsList = await getRecommendationsList(
          0, 1000, '', 'with_doctor_and_nutritionist', undefined, undefined, memberUserId
        );
        dispatch(setMemberRecommendations(memberRecommendationsList));
      } catch (error) {
        console.error('Error fetching member recommendations:', error);
      } finally {
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching recommendations:', error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, memberUserId]);

  const fetchMemberRecommendations = useCallback(async () => {
    try {
      setLoading(true);
      const memberRecommendationsList = await getRecommendationsList(
        0, 1000, '', 'with_doctor_and_nutritionist', undefined, undefined, memberUserId
      );
      dispatch(setMemberRecommendations(memberRecommendationsList));
    } catch (error) {
      console.error('Error fetching member recommendations:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, memberUserId]);

  useEffect(() => {
    fetchAllRecommendations();
  }, [fetchAllRecommendations]);

  useEffect(() => {
    fetchMemberRecommendations();
  }, [selectedCategory, fetchMemberRecommendations]);

  if (loading) return <Loader />;
  if (error) return <div>Error loading recommendations...</div>;

  return (
    <div className='scroll-container recommendations-table'>
      <div className='table-container'>
        <TableHeader headerColumns={headerColumns} gap={'24px'} />
        <div className='table-body recommendations-table-body'>
          {memberRecommendations?.recommendations?.map((recommendation) => (
            <RecommendationsTableRow
              key={`${recommendation.id}`}
              recommendationData={recommendation}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default RecommendationsTable;
